import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import Antd from 'ant-design-vue';
import hljs from "highlight.js";
import 'highlight.js/styles/atom-one-dark.css' //样式
import 'ant-design-vue/dist/reset.css';
import 'github-markdown-css';
import * as Icons from '@ant-design/icons-vue';
import ContextMenu from "@/directives/ContextMenu";


import moment from 'moment';
moment.locale('zh-cn');

// main.js 或入口文件
const app = createApp(App);
// 全局注册所有图标

for (const iconName in Icons) {
    if (Icons[iconName].name) {
        app.component(Icons[iconName].name, Icons[iconName]);
    }
}

// 添加全局样式
const style = document.createElement('style')
style.textContent = `
  :root {
    --ant-color-primary: #576B95; /* 改为你想要的蓝色 */
    --ant-color-primary-hover: #40a9ff;
    --ant-color-primary-active: #096dd9;
    --ant-color-primary-outline: rgba(24, 144, 255, 0.2);
  }
`;
document.head.appendChild(style)

// 全局注册
app.use(store).use(router).use(Antd)
    .mount('#app');
app.config.globalProperties.$moment = moment;
//创建v-highlight全局指令
app.directive('highlight',function (el) {
    let blocks = el.querySelectorAll('pre code');
    blocks.forEach((block)=>{
        hljs.highlightBlock(block)
    })
});
app.directive('scrollToBottom', {
    // 当被绑定的元素插入到DOM中时...
    inserted(el) {
        // 滚动到元素的底部
        el.scrollTop = el.scrollHeight;
    },
    // 当绑定的数据更新时...
    componentUpdated(el) {
        // 如果你想要在内容更新时保持滚动到底部，可以在这里实现
        el.scrollTop = el.scrollHeight;
    }
});
app.directive('contextmenu', ContextMenu);